import "./style.scss";
import { createPortal } from "react-dom";
import { useEffect } from "react";

const ModalPortal = ({ children }: { children: React.ReactNode }) => {
  const modalRoot = document.getElementById("modal-root");

  useEffect(() => {
    if (!modalRoot) return;

    if (children) {
      modalRoot.classList.add("active");
    } else {
      modalRoot.classList.remove("active");
    }

    return () => {
      modalRoot.classList.remove("active");
    };
  }, [children, modalRoot]);

  if (!modalRoot) return null;

  return createPortal(children, modalRoot);
};

export default ModalPortal;
